/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import styled from "styled-components";

export const UnstyledLink = styled.a`
  color: inherit;
  text-decoration: none;
`;

export const StyledLink = styled.a`
  text-decoration: none;
  color: inherit;

  &:focus,
  &:visited,
  &:link,
  &:active {
    text-decoration: none;
    text-decoration: color;
  }

  &:hover {
    text-decoration: underline;
  }
`;

// for use inside of a <Link>
export const UnderlineOnlyLinkStyle = styled.a`
  user-select: none;
  color: inherit;
  text-decoration: none;
  :hover {
    text-decoration: underline;
  }
  &:visited {
    color: inherit;
  }
`;
